// Define ui-dropdown as a primitive
AFRAME.registerPrimitive('ui-dropdown', {
    defaultComponents: {
        'ui-dropdown': {}
    },
    mappings: {
        options: 'ui-dropdown.options',
        width: 'ui-dropdown.width',
        height: 'ui-dropdown.height',
        color: 'ui-dropdown.color',
        'text-color': 'ui-dropdown.textColor',
        label: 'ui-dropdown.label' // New label attribute
    }
});

// Register the ui-dropdown component
AFRAME.registerComponent('ui-dropdown', {
    schema: {
        options: { type: 'array', default: [] },
        width: { type: 'number', default: 1.5 },
        height: { type: 'number', default: 0.2 },
        color: { type: 'string', default: '#24445e' },
        textColor: { type: 'string', default: 'white' },
        label: { type: 'string', default: '' } // New label property
    },

    init: function () {
        this.currentIndex = 0;
        this.isOpen = false;
        this.optionButtons = [];
        this.scrollOffset = 0;
        this.maxVisibleItems = 5;
        this.parsedOptions = this.parseOptions(this.data.options);
        this.createDropdown();
        this.bindEvents();
    },

    parseOptions: function (options) {
        let parsed;
        if (typeof options === 'string') {
            try {
                parsed = JSON.parse(options);
                console.log('Options parsed from string - raw:', options, 'parsed:', parsed);
            } catch (e) {
                console.error('Failed to parse options:', options, 'Error:', e);
                parsed = [options];
            }
        } else {
            parsed = options;
            console.log('Options already an array:', options);
        }
        const cleanedOptions = parsed.map(option => String(option).replace(/["[\]]/g, '').trim());
        console.log('Cleaned options:', cleanedOptions);
        return cleanedOptions;
    },

    createDropdown: function () {
        const { width, height, color, textColor, label } = this.data;

        // Label above dropdown button
        if (label) {
            this.labelText = document.createElement('a-text');
            this.labelText.setAttribute('value', label);
            this.labelText.setAttribute('align', 'center');
            this.labelText.setAttribute('position', `0 ${height} 0`);
            this.labelText.setAttribute('color', textColor);
            this.labelText.setAttribute('font', 'roboto');
            this.labelText.setAttribute('shader', 'msdf');
            this.labelText.setAttribute('negate', 'true');
            this.labelText.setAttribute('scale', '0.5 0.5 0.5');
            // Disable raycasting to pass events through
            this.labelText.setAttribute('class', 'no-raycast'); // Custom class to exclude from raycaster
            this.el.appendChild(this.labelText);
        }

        // Base button (rounded-box)
        this.baseButton = document.createElement('ui-button');
        this.baseButton.setAttribute('type', 'rounded-box');
        this.baseButton.setAttribute('label', this.parsedOptions[0] || 'Select');
        this.baseButton.setAttribute('width', width);
        this.baseButton.setAttribute('height', height);
        this.baseButton.setAttribute('depth', 0.05);
        this.baseButton.setAttribute('radius', 0.05);
        this.baseButton.setAttribute('color', color);
        this.baseButton.setAttribute('opacity', 0.8);
        this.baseButton.setAttribute('position', '0 0 0');
        this.el.appendChild(this.baseButton);

        // Dropdown list container
        this.listContainer = document.createElement('a-entity');
        this.listContainer.setAttribute('visible', false);
        this.listContainer.setAttribute('position', '0 0 0.08');
        this.el.appendChild(this.listContainer);

        // Rounded-plane background with white border
        this.backgroundPlane = document.createElement('a-rounded-plane');
        this.backgroundPlane.setAttribute('width', width * 1.1);
        this.backgroundPlane.setAttribute('height', this.maxVisibleItems * height * 1.15);
        this.backgroundPlane.setAttribute('radius', 0.05);
        this.backgroundPlane.setAttribute('color', '#333');
        this.backgroundPlane.setAttribute('opacity', 0.9);
        this.backgroundPlane.setAttribute('border-color', '#FFF');
        this.backgroundPlane.setAttribute('border-opacity', 1.0);
        const listHeight = this.maxVisibleItems * height * 1.1;
        this.backgroundPlane.setAttribute('position', `${-width * 1.1 / 2 } ${-height * 1.8 * 2 - listHeight / 2} 0.06`);
        this.listContainer.appendChild(this.backgroundPlane);

        // Generate option buttons
        this.updateOptionList();
    },

    updateOptionList: function () {
        const { width, height, color } = this.data;

        // Clear existing buttons
        this.optionButtons.forEach(button => this.listContainer.removeChild(button));
        this.optionButtons = [];

        // Create option buttons, skipping the first item (index 0)
        for (let index = 1; index < this.parsedOptions.length; index++) {
            const option = this.parsedOptions[index];
            const optionButton = document.createElement('ui-button');
            optionButton.setAttribute('type', 'plane');
            optionButton.setAttribute('label', option);
            optionButton.setAttribute('width', width);
            optionButton.setAttribute('height', height);
            optionButton.setAttribute('color', color);
            optionButton.setAttribute('opacity', 0.9);
            optionButton.setAttribute('position', `0 ${-index * height - 1} 0.01`); // 0.01 above plane
            optionButton.addEventListener('click', () => {
                this.selectOption(index);
            });
            this.optionButtons.push(optionButton);
            this.listContainer.appendChild(optionButton);
        }

        // Apply initial scroll offset
        this.updateScrollPosition();
    },

    bindEvents: function () {
        // Toggle list visibility and extend base button
        this.baseButton.addEventListener('click', (event) => {
            event.stopPropagation(); // Prevent event bubbling
            this.isOpen = !this.isOpen;
            this.listContainer.setAttribute('visible', this.isOpen);
            this.baseButton.setAttribute('position', `0 0 ${this.isOpen ? 0.02 : 0}`);
            console.log('Dropdown toggled:', this.isOpen ? 'open' : 'closed', 'Base button Z:', this.isOpen ? 0.02 : 0);
        });

        // Wheel event for scrolling
        this.listContainer.addEventListener('wheel', (event) => {
            if (!this.isOpen) return;

            event.preventDefault();
            const scrollSpeed = this.data.height * 0.5;
            this.scrollOffset += event.deltaY > 0 ? -scrollSpeed : scrollSpeed;

            const maxScroll = Math.max(0, (this.parsedOptions.length - 1 - this.maxVisibleItems) * this.data.height * 1.1);
            this.scrollOffset = Math.max(0, Math.min(this.scrollOffset, maxScroll));

            this.updateScrollPosition();
            console.log('Scrolled list, offset:', this.scrollOffset);
        });
    },

    updateScrollPosition: function () {
        const { height } = this.data;
        this.optionButtons.forEach((button, index) => {
            const yPos = -(index + 1) * height * 1.1 + this.scrollOffset;
            button.setAttribute('position', `0 ${yPos} 0.02`);
            const isVisible = yPos <= 0 && yPos >= -(this.maxVisibleItems * height * 1.1);
            button.setAttribute('visible', isVisible);
        });
    },

    selectOption: function (index) {
        this.currentIndex = index;
        const selectedValue = this.parsedOptions[index];
        this.baseButton.setAttribute('label', selectedValue);
        this.isOpen = false;
        this.listContainer.setAttribute('visible', false);
        this.baseButton.setAttribute('position', '0 0 0');
        this.el.emit('change', { value: selectedValue });
        console.log('Option selected:', selectedValue, 'index:', index);
    },

    update: function (oldData) {
        const { options, label } = this.data;
        if (options !== oldData.options || label !== oldData.label) {
            this.parsedOptions = this.parseOptions(options);
            this.currentIndex = 0;
            this.scrollOffset = 0;
            this.baseButton.setAttribute('label', this.parsedOptions[0] || 'Select');
            if (this.labelText && label !== oldData.label) {
                this.labelText.setAttribute('value', label);
            }
            this.updateOptionList();
            this.isOpen = false;
            this.listContainer.setAttribute('visible', false);
            this.baseButton.setAttribute('position', '0 0 0');
        }
    },

    remove: function () {
        this.optionButtons.forEach(button => button.removeEventListener('click', this.selectOption));
    }
});